<eau-auction-purchaser-container [auctionId]="auctionId"></eau-auction-purchaser-container>
